module.exports = __webpack_public_path__ + "56b45eca2301cc6a367e7c4533ebcc8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003CD6.png
// module id = 1551
// module chunks = 0